import React, { PropsWithChildren } from 'react';
import { FormattedMessage } from 'react-intl';
import { Alert, Col, Row } from 'reactstrap';

const BannerWrapper: React.FC<
  PropsWithChildren<{ isPartiallyFilled: boolean }>
> = ({ children, isPartiallyFilled }) => (
  <Alert className="alert-light py-4 mb-0">
    <Row>
      <Col className="col-auto">
        <i className="fe fe-zap" />
      </Col>
      <Col>
        <Row>
          <Col className="ms-n3 mb-2 mb-md-0">
            <h4 className="mt-1 mb-1">
              {isPartiallyFilled && (
                <FormattedMessage
                  id="app.views.performance.performance_person_assessment.ai_polish_cta"
                  defaultMessage="Let AI polish your draft review"
                />
              )}
              {!isPartiallyFilled && (
                <FormattedMessage
                  id="app.views.performance.performance_person_assessment.ai_draft_cta"
                  defaultMessage="Let AI save you time"
                />
              )}
            </h4>
            <p className="mb-0">
              {isPartiallyFilled && (
                <FormattedMessage
                  id="app.views.performance.performance_person_assessment.ai_polish_cta_secondary"
                  defaultMessage="Enhance your writing with data-backed insights and AI."
                />
              )}
              {!isPartiallyFilled && (
                <FormattedMessage
                  id="app.views.performance.performance_person_assessment.ai_draft_cta_secondary"
                  defaultMessage="Generate a first draft in seconds, then make it your own."
                />
              )}
            </p>
          </Col>
        </Row>
      </Col>
      <Col className="col-auto">{children}</Col>
    </Row>
  </Alert>
);

export default React.memo(BannerWrapper);
